/**
 * The asset path resolver service.
 */
var AssetPathResolverService = /** @class */ (function () {
    function AssetPathResolverService() {
        this.prefix = '';
    }
    /**
     * @param  {string} path
     */
    AssetPathResolverService.prototype.setPath = function (path) {
        this.prefix = path;
    };
    /**
     * @param  {string} assetPath
     * @return {string} Returns the asset path prefix.
     */
    AssetPathResolverService.prototype.getPath = function (assetPath) {
        return this.prefix + assetPath;
    };
    return AssetPathResolverService;
}());
export { AssetPathResolverService };
//# sourceMappingURL=asset-path-resolver.js.map